import { RouterProvider, matchPath } from 'react-router-dom'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'
import { ERoles } from 'models/auth'
import { ESellerStatus } from 'models/seller'
import { routes } from 'shared/constants/routes'
import { authRouter } from './authRouter'
import { adminRouter } from './adminRouter'
import { invitationRouter } from './invitationRouter'
import { sellerStatusRouter } from './sellerStatusRouter'
import { superAdminRouter } from './superAdminRouter'

export const Router: React.FC = () => {
  const isAuth = useAppSelector(appSelectors.selectIsAuth)
  const role = useAppSelector(appSelectors.selectRole)
  const sellerStatus = useAppSelector(appSelectors.selectSellerStatus)
  const isSellerApproved = !sellerStatus || sellerStatus === ESellerStatus.APPROVED
  let router = authRouter

  if (isAuth && role === ERoles.ADMIN) {
    router = superAdminRouter
  }

  if (isAuth && role === ERoles.USER) {
    router = adminRouter
  }

  // Неодобренному магазину бэкенд закрывает весь кабинет: показываем только
  // статус заявки, иначе продавец видит 403 на каждом разделе
  if (isAuth && role === ERoles.USER && !isSellerApproved) {
    router = sellerStatusRouter
  }

  // Приглашение принимают и из открытого кабинета: вход меняется на сотрудника
  if (
    matchPath(routes.INVITATION, window.location.pathname) ||
    matchPath(routes.ADMIN_INVITATION, window.location.pathname)
  ) {
    router = invitationRouter
  }

  return (
    <RouterProvider router={router} />
  )
}